// Modell + effort egy sorban („fable-5-1 | effort xhigh”): a szint színes, hogy a medium azonnal szemet szúrjon.
// A projekt műszerfala, a Terminál fül-sávja, a munkás-statisztika és a Beállítások is ezt használja.
export const EFFORT_ORDER = ['low', 'medium', 'high', 'xhigh', 'max'] as const;
export function shortModel(m: string | null | undefined): string { return m ? m.replace(/^claude-/, '') : ''; }

export function EffortTag({ level, word = true }: { level: string | null | undefined; word?: boolean }) {
  if (!level) return null;
  const known = (EFFORT_ORDER as readonly string[]).includes(level);
  return <>{word ? <span className="a-effort-word">effort </span> : null}<b className={`a-effort ${known ? level : 'other'}`}>{level}</b></>;
}

export function ModelEffort({ model, effort }: { model: string | null | undefined; effort: string | null | undefined }) {
  const m = shortModel(model);
  if (!m && !effort) return null;
  return <>{m}{m && effort ? <span className="a-sep"> | </span> : null}<EffortTag level={effort} /></>;
}
